/* CyberpunkPhotoManager 专属样式（其余复用 Admin.module.css） */

.photoGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  padding: 16px 0;
}

.photoCard {
  border: 1px solid #111;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.photoCardDeleted {
  opacity: 0.5;
  filter: grayscale(1);
}

.thumbWrap {
  aspect-ratio: 16 / 10;
  background: #f2f2f2;
  border-bottom: 2px solid #111;
  overflow: hidden;
}

.thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.photoMeta {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;
}

.metaName {
  font-weight: 700;
  word-break: break-all;
  line-height: 1.4;
}

.metaSub {
  color: #666;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.badgeRow {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}

.badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border: 1px solid #111;
  letter-spacing: 0.04em;
}

.badgeActive {
  background: #d8f5d8;
}

.badgeHidden {
  background: #fff3c4;
}

.badgeDeleted {
  background: #fdd;
}

.badgeMcp {
  background: #e0ecff;
}

.editRow {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.editInput {
  font-size: 12px;
  padding: 4px 8px;
  border: 1px solid #111;
  width: 100%;
}

.actionRow {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.hiddenFileInput {
  display: none;
}

.editTextarea {
  resize: vertical;
  min-height: 70px;
  line-height: 1.6;
  font-family: inherit;
}

.editLabel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #333;
}

.diaryExcerpt {
  color: #444;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
